function getBrowser() {
  const ua = navigator.userAgent;
  let tem;
  let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: (tem[1] || '') };
  }

  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) { return { name: 'Opera', version: tem[1] }; }
  }

  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];

  tem = ua.match(/version\/(\d+)/i);
  if (tem !== null) {
    M.splice(1, 1, tem[1]);
  }

  if (M[0] === 'MSIE') {
    M[0] = 'IE';
  }

  return {
    name: M[0],
    version: M[1],
  };
}

export const theFunction = () => {
  const browser = getBrowser().name.toLowerCase();
  const version = getBrowser().version;
  const class1 = ` browser-${browser}`;
  const class2 = ` browser-version-${version}`;
  document.body.className += class1;
  document.body.className += class2;
};

export default theFunction;



// WEBPACK FOOTER //
// ./src/lib/set-body-browser.js